import React, { Fragment, useEffect } from "react";
import connect from "react-redux/lib/connect/connect";
import { SetShowLeft } from "../../../common/actions/userActions";
import SportsLeague from "./SportsLeague";
import BigLeague from "./BigLeague";

const LeftBar = (props) => {

    const { type, title, showLeft } = props
    const view = () => {
        props.SetShowLeft(!showLeft)
    }

    return (
        <Fragment>
            <div className="contents_left" style={{ display: "block !important" }}>
                <SportsLeague type={type} title={title} view={view} />
                <BigLeague type={type} title={title} view={view}/>
            </div>
            <div id='left_bar' className="left_bar" onClick={view}>
                <span className="icon-menu"></span>
                <img src="../images/side-button.png" />
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    sports: state.sports,
    showLeft:state.user.showleft
});

export default connect(
    mapStateToProps,
    {
        SetShowLeft
    }
)(LeftBar);


// WEBPACK FOOTER //
// ./src/components/sports/sportscomponent/LeftBar.js